import { render, staticRenderFns } from "./BuildingSelectItem.vue?vue&type=template&id=3dfa9b65&scoped=true&"
import script from "./BuildingSelectItem.vue?vue&type=script&lang=js&"
export * from "./BuildingSelectItem.vue?vue&type=script&lang=js&"
import style0 from "./BuildingSelectItem.vue?vue&type=style&index=0&id=3dfa9b65&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dfa9b65",
  null
  
)

export default component.exports